import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import { useSetHighestZIndexToNode } from 'components/canvas/hooks/use-set-heighest-z-index-to-node';

export function useOnSurfaceNodeSave(operationName) {
  const saveNodeInCache = useSaveNodeInCache();
  const setHighestZIndexToNode = useSetHighestZIndexToNode();
  // @ts-ignore
  return function update(cache, { data }) {
    const { [operationName]: response } = data;

    if (response.error) {
      return;
    }

    const node = response.data;

    const isNotRisDocument = node.fromRis === false;

    setHighestZIndexToNode(node);

    if (isNotRisDocument) {
      // skip update because it will be updated when file is uploaded
      return;
    }

    saveNodeInCache(node);
  };
}
